import apiClient from '../apiClient';
import { GET_TOUR_TRANSACTION_BILLED_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getTourTransactionBilledApi = Id => {
  return apiClient.get(GET_TOUR_TRANSACTION_BILLED_BY_TRANSACTION_ID_URL(Id));
};

export default getTourTransactionBilledApi;
